module.exports = __webpack_public_path__ + "img/cover-enterprise.97263ee0.jpg";